<app-ion-common-header [id]="headerId" [labelBtnBack]="labelBtnBack" (backHeader)="backPage()" (focusHeader)="shownContent()"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">
    <app-ion-common-label
        *ngIf="titleContent"
        labelStyle="display-rg"
        ariaLevel="1"
        [labelDescription]="titleContent"
    ></app-ion-common-label>

    <div class="content">
        <div [innerHTML]="content"></div>
    </div>
    
</ion-content>
